import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { mahsooleShisheColumn } from "Constants/TableColumns";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { Grid } from "@material-ui/core";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { read } from "Helpers/LocalStorage";
import {
  EditPriceMahsooleShishe,
  disableMahSooleShishe,
  GetAllMahsooleShishe,
  changeMahsooleShisheSearch,
} from "Stores/actions";
import cellEditFactory from "react-bootstrap-table2-editor";
import Input from "Components/Input/Input";
import { ReactSVG } from "react-svg";
import Search from "Assets/svg/icon/search.svg";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { useTranslation } from 'react-i18next';

function TblShishe() {
  const { t } = useTranslation();
  const { mahsooleShishe, mahsooleShishePagination, mahsooleShisheDataSearch, rtlLayout} =
    useSelector((state) => ({
      mahsooleShishe: state.shishe.mahsooleShishe,
      mahsooleShisheDataSearch: state.shishe.mahsooleShisheDataSearch,
      mahsooleShishePagination: state.shishe.mahsooleShishePagination,
      rtlLayout: state.settings.rtlLayout,
    }));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [sizePerPage, setSizePerPage] = useState(
    mahsooleShishePagination.Limit
  );
  const [currentPage, setCurrentPage] = useState(mahsooleShishePagination.Page);
  const [total, setTotal] = useState(1);
  const [tblData, setTblData] = useState(mahsooleShishe);
  const [columns, setColumns] = useState(null);

  useEffect(() => {
    if (mahsooleShishe) {
      const isAdmin = read("StypeU") === "1";
      const isRecordRegisteredByAdmin = mahsooleShishe?.IsG;
      const isUserHasAccessPrice2 = read("mahsoleShisheRules").accessPrice2;
      const updatemahsooleShisheColumn = [...mahsooleShisheColumn];
      const isAllAdmin = mahsooleShishe.every((item) => item.IsG);
      updatemahsooleShisheColumn[7].hidden = isAdmin || (isUserHasAccessPrice2 === false && isRecordRegisteredByAdmin) || (isAllAdmin && isUserHasAccessPrice2 === false);
      updatemahsooleShisheColumn[2].align = rtlLayout ? "right" : "left";
      updatemahsooleShisheColumn[2].headerAlign= rtlLayout ? "right" : "left";
      setColumns(updatemahsooleShisheColumn);
    }
    return () => setColumns(null);
  }, [mahsooleShishe]);

  useEffect(() => {
    if (mahsooleShishe) {
      setTblData(mahsooleShishe);
      setTotal(mahsooleShishePagination.Total);
    }
  }, [mahsooleShishe, mahsooleShishePagination]);

  const BeforeSaveCell = async (oldValue, newValue, row, column, done) => {
    newValue = convertToEnglishNumber(newValue) < 0 
      ? (-1 * convertToEnglishNumber(newValue)) 
      : convertToEnglishNumber(newValue);
    if (column.dataField === "Disable") {
      const updateNewValue = JSON.parse(newValue);
      if (oldValue !== updateNewValue) {
        try {
          setLoading(true);
          const data = {
            KeyGroup: read("groupKey"),
            keyUser: read("userKey"),
            Id: Number(row.Id),
            Disable: updateNewValue,
          };
          await dispatch(disableMahSooleShishe(data));
          //todo seo
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: mahsooleShisheDataSearch?.Name,
            Limit: mahsooleShishePagination.Limit,
            Page: mahsooleShishePagination.Page,
          };
          await dispatch(GetAllMahsooleShishe(params));
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      } else {
        done(false);
      }
    }
    if (column.dataField === "GroupPrice" || column.dataField === "UserPrice") {
      const newPrice = isNaN(newValue) ? newValue.replaceAll(",", "") : newValue;
      const oldPrice = oldValue.replaceAll(",", "");
      if (parseFloat(newPrice) !== parseFloat(oldPrice)) {
        try {
          setLoading(true);
          const data = {
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            Price: +newPrice,
            IdProduct: row.Id,
            IdProductGlass: row.Id,
          };
          await dispatch(EditPriceMahsooleShishe(data));
          //todo seo
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: mahsooleShisheDataSearch?.Name,
            Limit: mahsooleShishePagination.Limit,
            Page: mahsooleShishePagination.Page,
          };
          await dispatch(GetAllMahsooleShishe(params));
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      }
    }
  };

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: sizePerPage,
          Page: page,
          Name: mahsooleShisheDataSearch?.Name,
        };
        await dispatch(GetAllMahsooleShishe(params));
        setCurrentPage(page);
        setSizePerPage(sizePerPage);
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }
  };

  const setValue = (name, value) => {
    dispatch(changeMahsooleShisheSearch({ Name: value }));
  };

  const onSearch = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Limit: sizePerPage,
        Page: 1,
        Name: convertToEnglishNumber(mahsooleShisheDataSearch?.Name),
      };
      await dispatch(GetAllMahsooleShishe(params));
      setCurrentPage(1);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    dispatch(changeMahsooleShisheSearch({ Name: "" }));
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Limit: sizePerPage,
        Page: 1,
      };
      await dispatch(GetAllMahsooleShishe(params));
      setCurrentPage(1);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <Grid container spacing={2} className="mb-1">
        <Grid item lg={3} md={4} sm={6} xs={12}>
          <Input
            setValue={setValue.bind(this)}
            name="search"
            value={mahsooleShisheDataSearch ? mahsooleShisheDataSearch?.Name : ""}
            placeholder={t('searchGlassProName')}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Grid>
      </Grid>
      {columns && (
        <RemoteTable
          data={tblData}
          columns={columns}
          loading={loading}
          page={currentPage}
          sizePerPage={sizePerPage}
          totalSize={total}
          onTableChange={onTableChange}
          cellEdit={cellEditFactory({
            mode: "click",
            blurToSave: true,
            beforeSaveCell: (oldValue, newValue, row, column, done) =>
              BeforeSaveCell(oldValue, newValue, row, column, done),
          })}
          title={<Translator id="list_shishe" />}
        />
      )}
    </Fragment>
  );
}

export default TblShishe;
